import { render, staticRenderFns } from "./IntelligentAssistant.vue?vue&type=template&id=d464838c&scoped=true"
import script from "./IntelligentAssistant.vue?vue&type=script&lang=js"
export * from "./IntelligentAssistant.vue?vue&type=script&lang=js"
import style0 from "./IntelligentAssistant.vue?vue&type=style&index=0&id=d464838c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d464838c",
  null
  
)

export default component.exports